module.exports = flarum.core.compat['models/Group'];